import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from '../style.css';
class AdminMenuArt extends Component {

  state = {
    locale: ""
  }

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <header class={style.header}>
        <nav class='secondary'>
          <Link href={"/"+this.props.locale+"/admin/art/literature/"}>{ this.props.locale == 'nl' ?'Literatuur':'Literature'}</Link>
          <Link href={"/"+this.props.locale+"/admin/art/keyword/"}>{ this.props.locale == 'nl' ?'Trefwoorden':'Keywords'}</Link>
          <Link href={"/"+this.props.locale+"/admin/art/author/"}>{ this.props.locale == 'nl' ?'Kunstenaars':'Artists'}</Link>
          <Link href={"/"+this.props.locale+"/admin/art/image/0"}>{ this.props.locale == 'nl' ?'Afbeeldingen':'Images'}</Link>
        </nav>
      </header>);
  }
}

export default AdminMenuArt;